export default __webpack_public_path__ + "static/media/JennyLim.cae24865.png";